import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Menu from 'components/Menu';
import Loading from 'components/Loading';
import { Title, Text } from 'components/Text';

import { getEula } from 'services/api/eula';

import { Wrapper } from './styles';

function Eula({ isPrivacy }) {
  const [eula, setEula] = useState('');
  const [loading, setLoading] = useState(true);

  async function loadEula() {
    try {
      const { data } = await getEula();
      setEula(data[0].text);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  // Init
  useEffect(() => {
    loadEula();
  }, []);

  // Quebrando o conteúdo entre Termos de Uso [terms] e Política de privacidade [privacy]
  const [terms, privacy] = eula ? eula.split(/-{3,}/) : ['', ''];
  // Retorna o objeto coms os dados da Política de Privacidade baseados na prop 'isPrivacy', senão retorna os Termos de Uso
  const content = isPrivacy ? { title: 'Política de Privacidade', text: privacy } : { title: 'Termos de Uso', text: terms };

  if (loading) return <Loading bg="white" />;

  return (
    <>
      <Menu />
      <Wrapper isPrivacy={isPrivacy}>
        <section>
          <Title>{content.title}</Title>
          <Text dangerouslySetInnerHTML={{
            __html: content.text,
          }}
          />
        </section>
      </Wrapper>
    </>
  );
}

Eula.defaultProps = {
  isPrivacy: false,
};

Eula.propTypes = {
  isPrivacy: PropTypes.bool,
};

export default Eula;
